module.exports = __webpack_public_path__ + "img/脚踏.SLDPRT.c3677347.jpg";